export function getLocalStorageOrCookie(id: string): string | undefined {
  return localStorage.getItem(id)
    ? localStorage.getItem(id)!
    : getCookie(id).length > 0
      ? getCookie(id)
      : undefined;
}

function getCookie(name: string): string {
  name += "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
